import clsx from 'clsx';
import React from 'react';
import styles from './PlanCard.module.scss';

interface Props {
    className?: string;
    children: React.ReactNode;
}

export const PlanCard: React.FunctionComponent<Props> = props => {
    return <div className={clsx(styles.root, props.className)}>{props.children}</div>;
};
